namespace TabAurous.Sales {
    export namespace SalesQuotationItemsService {
        export const baseUrl = 'Sales/QuotationItems';

        export declare function Create(request: Serenity.SaveRequest<SalesQuotationItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SalesQuotationItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SalesQuotationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SalesQuotationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<SalesQuotationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function QuotationCreatedBySpecSheet(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<SalesQuotationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Sales/QuotationItems/Create",
            Update = "Sales/QuotationItems/Update",
            Delete = "Sales/QuotationItems/Delete",
            Retrieve = "Sales/QuotationItems/Retrieve",
            List = "Sales/QuotationItems/List",
            CustomList = "Sales/QuotationItems/CustomList",
            QuotationCreatedBySpecSheet = "Sales/QuotationItems/QuotationCreatedBySpecSheet"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'QuotationCreatedBySpecSheet'
        ].forEach(x => {
            (<any>SalesQuotationItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
